export const LOAD_CUSTOMERS = "LOAD CUSTOMERS";
export const LOAD_CUSTOMER = "LOAD CUSTOMER";
export const ADD_CUSTOMER = "ADD CUSTOMER";
export const ADD_COMPANY = "ADD_COMPANY"
export const REMOVE_CUSTOMER = "REMOVE CUSTOMER";

export const CUSTOMER_STATE_IDLE = "idle";
export const CUSTOMER_STATE_LOADING = "loading";
export const CUSTOMER_STATE_IN_PROGRESS = "in progress";
export const CUSTOMER_STATE_FINISHED = "finished";
export const CUSTOMER_STATE_ERROR = "error";